
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DynamicFormControl } from '../../models/dynamic-form-control.model';
import { Subscription } from 'rxjs';
import { SubmissionConstants } from 'src/app/modules/energy-credits/models/constants/submissions-constants';
import { UsStateService } from '../../services/form-us-state.service';
import { PillButtonGroupComponent } from '../pill-button-group-control/pill-button-group.component';

@Component({
    selector: 'lib-climate-zone',
    imports: [
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    PillButtonGroupComponent
],
    templateUrl: './climate-zone-control.component.html',
    styleUrl: './climate-zone-control.component.scss'
})
export class ClimateZoneControlComponent {
  @Input() control: DynamicFormControl;
  @ViewChild('climateZone') pills: PillButtonGroupComponent;

  climateZone: any;

  private _subscriptions: Subscription[] = [];

  constructor(
    private readonly stateService: UsStateService,
    private readonly submissionConstant: SubmissionConstants
  ) {}

  ngOnInit() {
    this.setupHomeStateControlSubscription();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((i) => i.unsubscribe());
  }

  setupHomeStateControlSubscription() {
    const homeStateControl =
      this.control.formControls[0].formControl.parent.get('homeState');

    if (!homeStateControl) {
      return;
    }

    let stateSub = homeStateControl.valueChanges.subscribe((stateCode) => {
      if (!stateCode) {
        return;
      }
      const newClimateZone = this.getNewClimateZone(stateCode);
      localStorage.setItem(
        this.submissionConstant.climateZoneKey,
        newClimateZone
      );
      this.pills.setValue(newClimateZone);
    });
    this._subscriptions.push(stateSub);
  }

  private getNewClimateZone(stateCode: string): string {
    const states = this.stateService.stateList;
    const newClimateZone = (states ?? [])
      .find((state) => state.StateCode === stateCode)
      ?.HUDClimateZone?.toString();
    return newClimateZone;
  }
}
